import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';

const UsersTab = ({ users, onUpdateUserRole }) => {
  const getTierClassName = (tier) => {
    if (tier === 'elite') return 'bg-[#D4AF37]/20 text-[#D4AF37]';
    if (tier === 'premium') return 'bg-white/10 text-white';
    return 'bg-zinc-800 text-zinc-400';
  };

  return (
    <div className="bg-[#121212] border border-white/5 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-black/30">
            <tr>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">User</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Email</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Role</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Tier</th>
              <th className="text-left px-4 py-3 text-xs font-mono uppercase text-zinc-500">Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.user_id} className="border-t border-white/5">
                <td className="px-4 py-3 text-white">{user.name}</td>
                <td className="px-4 py-3 text-zinc-400 text-sm">{user.email}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-1 ${user.role === 'admin' ? 'bg-[#D4AF37]/20 text-[#D4AF37]' : 'bg-zinc-800 text-zinc-400'}`}>
                    {user.role}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-1 capitalize ${getTierClassName(user.subscription_tier)}`}>
                    {user.subscription_tier}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <Select 
                    value={user.role} 
                    onValueChange={(value) => onUpdateUserRole(user.user_id, value)}
                  >
                    <SelectTrigger className="w-24 h-8 bg-zinc-800 border-zinc-700 text-xs">
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent className="bg-[#121212] border-zinc-700">
                      <SelectItem value="user">User</SelectItem>
                      <SelectItem value="admin">Admin</SelectItem>
                    </SelectContent>
                  </Select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTab;
